import { useQuery } from '@tanstack/react-query';
import { settlementsApi } from '../api/settlementsApi';

export const useMerchantSettlements = (tenantId: string) =>
  useQuery({
    queryKey: ['settlements', tenantId],
    queryFn: () => settlementsApi.listByMerchant(tenantId),
    staleTime: 60 * 1000,
    enabled: !!tenantId,
  });
